export const getErrorMessage = ({ displayName }: { displayName?: string }) =>
    displayName
        ? `use${displayName} has to be used within <${displayName}.Provider>`
        : 'useContext has to be used within corresponding <Context.Provider>';
